import { DataGrid } from "@mui/x-data-grid";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  FormGroup,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import { AiOutlineSearch } from "react-icons/ai";
import { useState, useEffect } from "react";
import "./../../barrasuperior/index.css";

import AutocompleteTextArea from "../multipleUserInput/multipleUserInput";
import "./../../bibliotecacomponents/crearSubcategoriaDewey/crearSubcategoriaDewey.css";
import { renderStarRating } from "../../../utils/functions";
import {
  crearLibroConAutoresYUbicacion,
  deshabilitarLibro,
  actualizarLibro,
  obtenerLibrosPaginados,
  buscarLibros,
} from "../../../services/LibrosService";
import {
  agregarAutor,
  obtenerTodosLosAutores,
} from "../../../services/AutorService";
import { obtenerTodasLasCategorias } from "../../../services/CategoriaService";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { SearchOrAdd } from "../searchOrAdd/searchOrAdd";
import Swal from "sweetalert2";
import "./inventariotable.css";
import { obtenerTodasLasCategoriasDewey } from "../../../services/CategoriaDeweyService";
import { CreateAuthor } from "../crearAutorForm/crearAutorForm";
import { CreateDeweySubcategory } from "../crearSubcategoriaDewey/crearSubcategoriaDewey";
import { obtenerFondos } from "../../../services/FondoService";
import JumpByItemFooter from "../customTableFooter/JumpByItemFooter";
import {
  crearGenero,
  obtenerTodosLosGeneros,
} from "../../../services/GeneroService";
import { CreateGenre } from "../crearGeneroForm/createGenre";
import DownloadInventarioExcel from "../downlaodInventario";
import defaultBookPic from "../../../assets/defaultBook.png";

function TablaInventario() {
  const [categorias, setCategorias] = useState([]);
  const [fondos, setFondos] = useState([]);
  const [categoriasDewey, setCategoriasDewey] = useState([]);
  const [pagingMetadata, setPagingMetadata] = useState({ totalElements: 0 });
  const [bookPageId, setBookPageId] = useState(0);
  const [bookPageSize, setBookPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [generoField, setGeneroField] = useState("");
  const [autores, setAutores] = useState([]);
  const [libros, setLibros] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [loading, setLoading] = useState(false);

  const [dialogoAbierto, setDialogoAbierto] = useState(false);
  const [autorSeleccionado, setAutorSeleccionado] = useState(null);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
  const [categoriaDeweySeleccionada, setCategoriaDeweySeleccionada] = useState(null);

  const [isGenreCreationDialogueOpen, setIsGenreCreationDialogueOpen] =
    useState(false);

  const [isAuthorDialogueOpen, setIsAuthorDialogueOpen] = useState(false);
  const [isDeweySubcategoryDialogueOpen, setIsDeweySubcategoryDialogueOpen] =
    useState(false);

  const [autor, setAutor] = useState({});

  const [subcategoriasDeweyDisponibles, setSubCategoriaDeweyDisponibles] =
    useState([]);
  const [subcategoriaDeweySeleccionada, setSubCategoriaDeweySeleccionada] = useState(null);
  const [fondoSeleccionado, setFondoSeleccionado] = useState(null);

  const initialNuevoLibroState = {
    titulo: "",
    sinopsis: "",
    imagen: "",
    genero: "",
    añoPublicacion: "",
    isbn: "",
    publicacionDistribucion: "",
    descripcionFisica: "",
    numCopiasTotales: "",
    numCopiasDisponibles: "",
    precio: "",
    prestable: false,
    prestamoEspecial: false,
    area: "",
    numEstante: "",
    numRepisa: "",
    autorId: "",
    categoriaId: "",
    codigoCategoriaDewey: "",
    subcategoriaDeweyId: "",
    fondoId: "",
    codigosCopias: [],
    palabrasClave: [],
  };

  const [nuevoLibro, setNuevoLibro] = useState(initialNuevoLibroState);

  const resetNuevoLibro = () => {
    setNuevoLibro(initialNuevoLibroState);
  };

  const [libroSeleccionado, setLibroSeleccionado] = useState(null);

  useEffect(() => {
    setNuevoLibro((prev) => ({
      ...prev,
      autorId: autorSeleccionado?.idAutor ?? "",
      categoriaId: categoriaSeleccionada?.idCategoria ?? "",
      codigoCategoriaDewey: categoriaDeweySeleccionada?.codigoCategoria ?? "",
      subcategoriaDeweyId: subcategoriaDeweySeleccionada?.idSubcategoria ?? "",
      fondoId: fondoSeleccionado?.idFondo ?? "",
      genero: generoField ?? "",
    }));
  }, [
    generoField,
    autorSeleccionado,
    categoriaSeleccionada,
    categoriaDeweySeleccionada,
    subcategoriaDeweySeleccionada,
    fondoSeleccionado,
  ]);

  const fetchFondos = async () => {
    const data = await obtenerFondos();
    setFondos(data);
  };

  const fetchLibros = async () => {
    try {
      const data = await obtenerLibrosPaginados(bookPageId, bookPageSize);
      const { content, ...pagingMetadata } = data;
      setPagingMetadata(pagingMetadata);
      setLibros(content.map((obj) => obj.libro));
    } catch (error) {
      Swal.fire("Error", "No se encontró el préstamo", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchLibros();
  }, [bookPageId, bookPageSize]);

  const fetchCategoriasDewey = async () => {
    const data = await obtenerTodasLasCategoriasDewey();
    setCategoriasDewey(data);
  };

  const fetchCategorias = async () => {
    const data = await obtenerTodasLasCategorias();
    setCategorias(data);
  };
  const fetchAutores = async () => {
    const data = await obtenerTodosLosAutores();
    setAutores(data);
  };

  const fetchGeneros = async () => {
    const data = await obtenerTodosLosGeneros();
    setGeneros(data.map((genre) => genre.nombre));
  };

  useEffect(() => {
    setLoading(true);
    fetchLibros();
    fetchCategoriasDewey();
    fetchCategorias();
    fetchAutores();
    fetchFondos();
    fetchGeneros();
  }, []);

  useEffect(() => {
    if (libroSeleccionado) {
      setNuevoLibro({
        titulo: libroSeleccionado.titulo,
        sinopsis: libroSeleccionado.sinopsis,
        imagen: libroSeleccionado.imagen,
        isbn: libroSeleccionado.isbn,
        genero: libroSeleccionado.genero,
        numCopiasTotales: libroSeleccionado.numCopiasTotales,
        numCopiasDisponibles: libroSeleccionado.numCopiasDisponibles,
        añoPublicacion: libroSeleccionado.añoPublicacion,
        area: libroSeleccionado.ubicacion?.area,
        numEstante: libroSeleccionado.ubicacion?.numEstante,
        numRepisa: libroSeleccionado.ubicacion?.numRepisa,
        publicacionDistribucion: libroSeleccionado.publicacionDistribucion,
        descripcionFisica: libroSeleccionado.descripcionFisica,
        precio: libroSeleccionado.precio,
        prestable: libroSeleccionado.prestable,
        prestamoEspecial: libroSeleccionado.prestamoEspecial,
        autorId: libroSeleccionado.autor?.idAutor,
        categoriaId: libroSeleccionado.categoria?.idCategoria,
        codigoCategoriaDewey: libroSeleccionado.categoriaDewey?.codigoCategoria,
        subcategoriaDeweyId:
          libroSeleccionado.subcategoriaDewey?.idSubcategoria,
        fondoId: libroSeleccionado.fondo?.idFondo,
        codigosCopias: libroSeleccionado.copias?.map(
          (copia) => copia.codigoCopia,
        ) ?? [],
        palabrasClave: libroSeleccionado.palabrasClave,
      });
      setCategoriaSeleccionada(libroSeleccionado.categoria);
      setCategoriaDeweySeleccionada(libroSeleccionado.categoriaDewey);
      setSubCategoriaDeweyDisponibles(
        libroSeleccionado.categoriaDewey?.subcategorias ?? [],
      );
      setSubCategoriaDeweySeleccionada(libroSeleccionado.subcategoriaDewey);
      setFondoSeleccionado(libroSeleccionado.fondo);
      setAutorSeleccionado(libroSeleccionado.autor);
      setGeneroField(libroSeleccionado.genero);
    }
  }, [libroSeleccionado]);

  const handleCrearLibro = async () => {
    try {
      if (!nuevoLibro.codigosCopias.length) {
        throw Error("Registrá al menos un código de copia física");
      }

      await crearLibroConAutoresYUbicacion(nuevoLibro);
      const data = await obtenerLibrosPaginados(bookPageId, bookPageSize);
      const { content } = data;
      setLibros(content.map((obj) => obj.libro));
      setDialogoAbierto(false);
      resetNuevoLibro();
      Swal.fire({
        title: "Éxito!",
        text: "El libro se ha guardado con éxito.",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
      fetchLibros();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: `No se pudo guardar el libro. ${error.toString()}`,
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    }
  };

  const handleActualizarLibro = async () => {
    try {
      if (!nuevoLibro.codigosCopias.length) {
        throw Error("Registrá al menos un código de copia física");
      }
      await actualizarLibro(libroSeleccionado.idLibro, nuevoLibro);
      Swal.fire({
        title: "Éxito!",
        text: "El libro se ha actualizado con éxito.",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
      fetchLibros();
      setDialogoAbierto(false);
      setLibroSeleccionado(null);
      setFondoSeleccionado(null);
      setCategoriaSeleccionada(null);
      setCategoriaDeweySeleccionada(null);
      setSubCategoriaDeweyDisponibles([]);
      setSubCategoriaDeweySeleccionada(null);
      setAutorSeleccionado(null);
      resetNuevoLibro();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.response?.data || error.message || "No se pudo actualizar el libro.",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    }
  };

  const handleDeshabilitarLibro = async (idLibro) => {
    const resultado = await Swal.fire({
      title: "¿Estás seguro de eliminar el libro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#21807C",
      cancelButtonColor: "#d33",
    });

    if (resultado.isConfirmed) {
      try {
        await deshabilitarLibro(idLibro);
        Swal.fire({
          title: "Éxito!",
          text: "El libro se ha eliminado con éxito.",
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#21807C",
        });
        fetchLibros();
      } catch (error) {
        Swal.fire("Error", "No se pudo eliminar el libro", error);
      }
    }
  };

  const handleChange = (e) => {
    setNuevoLibro({ ...nuevoLibro, [e.target.name]: e.target.value });
  };

  const handleSearch = async (e) => {
    if (searchTerm == "") {
      await fetchLibros();
      return;
    }

    e.preventDefault();
    setLoading(true);
    const response = await buscarLibros(searchTerm);
    setLibros(response.data);
    setLoading(false);
    setSearchTerm("");
  };

  const columnas = [
    {
      field: "idLibro",
      headerName: "ID",
      width: 120,
      headerClassName: "tablaInventario-headers",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "imagen",
      headerName: "Imagen",
      width: 150,
      headerClassName: "tablaInventario-headers",
      renderCell: (params) => (
        <img
          src={params.value || defaultBookPic}
          alt="Portada del libro"
          style={{ width: 50 }}
        />
      ),
    },
    {
      field: "titulo",
      headerName: "Título",
      width: 200,
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "sinopsis",
      headerName: "Sinopsis",
      width: 400,
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "añoPublicacion",
      headerName: "Año Publicación",
      width: 130,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "isbn",
      headerName: "ISBN",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "numCopiasTotales",
      headerName: "Copias Totales",
      type: "number",
      width: 130,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "numCopiasDisponibles",
      headerName: "Copias Disponibles",
      type: "number",
      width: 160,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "calificacionPromedio",
      headerName: "Calificación Promedio",
      width: 160,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
      renderCell: (params) =>
        renderStarRating(params.row.calificacionPromedio /*"calificado"*/),
    },
    {
      field: "numCalificaciones",
      headerName: "Número de Calificaciones",
      type: "number",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "ubicacion",
      headerName: "Ubicación",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
      valueGetter: (params) =>
        `Estante: ${params.row.ubicacion?.numEstante ?? "N/A"} Repisa: ${params.row.ubicacion?.numRepisa ?? "N/A"}`,
    },
    {
      field: "autor",
      headerName: "Autor",
      width: 200,
      headerClassName: "tablaInventario-headers",
      valueGetter: (params) => params.row.autor.nombreAutor,
    },
    {
      field: "fondo",
      headerName: "Fondo",
      width: 200,
      headerClassName: "tablaInventario-headers",
      valueGetter: (params) => params.row.fondo.nombreFondo,
    },
    {
      field: "genero",
      headerName: "Genero",
      width: 200,
      headerClassName: "tablaInventario-headers",
    },
    {
      field: "categoriaDewey",
      headerName: "Categoría Dewey",
      width: 200,
      headerClassName: "tablaInventario-headers",
      valueGetter: (params) => params.row.categoriaDewey.nombreCategoria,
    },
    {
      field: "subcategoriaDewey",
      headerName: "Subcategoría Dewey",
      width: 200,
      headerClassName: "tablaInventario-headers",
      valueGetter: (params) =>
        params.row.subcategoriaDewey?.nombreSubcategoria ?? "N/A",
    },
    {
      field: "acciones",
      headerName: "Acciones",
      sortable: false,
      lockVisible: false,
      width: 160,
      headerAlign: "center",
      headerClassName: "tablaInventario-headers",
      renderCell: (params) => (
        <>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              onClick={() => {
                setLibroSeleccionado(params.row);
                setDialogoAbierto(true);
              }}
              style={{
                width: "40px",
                height: "40px",
              }}
              className="tableInventario-updateBtn"
            >
              <FaEdit color="white" />
            </Button>
            <Button
              onClick={() => handleDeshabilitarLibro(params.row.idLibro)}
              className="tableInventario-deleteBtn"
              style={{
                width: "40px",
                height: "40px",
              }}
            >
              <FaTrashAlt color="white" />
            </Button>
          </div>
        </>
      ),
    },
  ];

    return (
      <div>
        <div className="inventarioBtn-container">
          <div className="inventarioBtn-left">
            <form className="barra-searchContainer" onSubmit={handleSearch}>
              <AiOutlineSearch size={20} style={{ color: "#909090" }} />
              <input
                type="text"
                placeholder="Buscar un libro"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </form>
            <button
              className="tableInventario-crearBtn"
              onClick={() => setDialogoAbierto(true)}
            >
              Añadir Libro
            </button>
          </div>

          <DownloadInventarioExcel />
        </div>

        <Dialog open={dialogoAbierto} onClose={() => setDialogoAbierto(false)}>
          <DialogTitle>
            {libroSeleccionado ? "Editar Libro" : "Crear Nuevo Libro"}
          </DialogTitle>
          <DialogContent>
            <TextField
              required
              label="Título"
              name="titulo"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.titulo}
            />
            <TextField
              required
              label="Sinopsis"
              name="sinopsis"
              onChange={handleChange}
              inputProps={{ maxLength: 380 }}
              fullWidth
              multiline
              rows={4}
              margin="dense"
              value={nuevoLibro.sinopsis}
            />
            {nuevoLibro.imagen && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src={nuevoLibro.imagen}
                  alt="Vista previa de la imagen"
                  style={{
                    maxWidth: "100%",
                    marginTop: "10px",
                    height: "220px",
                    justifySelf: "center",
                  }}
                />
              </div>
            )}
            <TextField
              label="Imagen URL"
              name="imagen"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.imagen}
            />
            <TextField
              required
              label="Año Publicación"
              name="añoPublicacion"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.añoPublicacion}
            />
            <TextField
              required
              label="ISBN"
              name="isbn"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.isbn}
            />
            <TextField
              label="Publicador"
              required
              name="publicacionDistribucion"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.publicacionDistribucion}
            />
            <TextField
              label="Descripción Fisica"
              required
              name="descripcionFisica"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.descripcionFisica}
            />
            <TextField
              label="Precio"
              name="precio"
              required
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.precio}
            />
            <TextField
              label="Número de Copias Totales"
              fullWidth
              margin="dense"
              InputProps={{ readOnly: true }}
              value={nuevoLibro.codigosCopias.length}
              helperText={`Códigos registrados: ${nuevoLibro.codigosCopias.length}. Las cantidades se calculan a partir de las copias.`}
            />
            <TextField
              label="Número de Copias Disponibles"
              fullWidth
              margin="dense"
              InputProps={{ readOnly: true }}
              value={libroSeleccionado ? (nuevoLibro.numCopiasDisponibles ?? "Sin registro") : nuevoLibro.codigosCopias.length}
              helperText="Se recalcula al guardar según las copias y los préstamos activos."
            />
            <AutocompleteTextArea
              label="Códigos de copia*"
              placeholder="Ingresá el código físico y presioná Enter..."
              values={nuevoLibro.codigosCopias}
              setValues={(codigos) => setNuevoLibro((prev) => ({ ...prev, codigosCopias: codigos }))}
              maxInputs={Number.MAX_SAFE_INTEGER}
            />
            <TextField
              label="Área"
              name="area"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.area}
            />
            <TextField
              label="Número de Estante"
              name="numEstante"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.numEstante}
            />
            <TextField
              label="Número de Repisa"
              name="numRepisa"
              onChange={handleChange}
              fullWidth
              margin="dense"
              value={nuevoLibro.numRepisa}
            />
            <AutocompleteTextArea
              label="Palabras Clave"
              placeholder="Ingresa una palabra y presiona ingresar"
              values={nuevoLibro.palabrasClave}
              setValues={(palabras) =>
                setNuevoLibro((prev) => ({ ...prev, palabrasClave: palabras }))
              }
              maxInputs={100}
            />
            <FormControl fullWidth margin="dense">
              <SearchOrAdd
                label={"Genero*"}
                value={generoField}
                givenOptions={generos ? generos : ["Cargando opciones..."]}
                hasAddForm={true}
                setIsCreationDialogueOpen={setIsGenreCreationDialogueOpen}
                isCreationDialogueOpen={isGenreCreationDialogueOpen}
                addForm={
                  <CreateGenre
                    onAdd={(picked) => {
                      setGeneros((prev) => [...prev, picked]);
                      setGeneroField(picked);
                    }}
                    title={"Agregar Genero"}
                    confirmationText={"Crear"}
                    actionFunction={crearGenero}
                    isOpen={isGenreCreationDialogueOpen}
                    setIsOpen={setIsGenreCreationDialogueOpen}
                    generoField={generoField}
                    setGeneroField={setGeneroField}
                  />
                }
                onChange={(e, value, reason) => {
                  if (reason === "clear") {
                    setGeneroField("");
                    return;
                  }
                  if (reason === "selectOption") {
                    setGeneroField(value);
                  }
                }}
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <SearchOrAdd
                value={fondoSeleccionado}
                label={"Fondo*"}
                givenOptions={fondos ? fondos : ["Cargando opciones..."]}
                hasAddForm={false}
                getOptionLabel={(option) =>
                  option.nombreFondo
                    ? `${option.nombreFondo} - ${option.idFondo}`
                    : ""
                }
                onChange={(e, value, reason) => {
                  if (reason === "clear") {
                    setFondoSeleccionado(null);
                    return;
                  }
                  if (reason === "selectOption") {
                    setFondoSeleccionado(value);
                  }
                }}
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <SearchOrAdd
                value={categoriaSeleccionada}
                label={"Categoría*"}
                hasAddForm={false}
                givenOptions={
                  categorias ? categorias : ["Cargando opciones..."]
                }
                getOptionLabel={(option) => option.nombreCategoria || ""}
                onChange={(e, value, reason) => {
                  if (reason === "clear") {
                    setCategoriaSeleccionada(null);
                    return;
                  }
                  if (reason === "selectOption") {
                    setCategoriaSeleccionada(value);
                  }
                }}
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <SearchOrAdd
                value={categoriaDeweySeleccionada}
                label={"Categoria Dewey*"}
                hasAddForm={false}
                givenOptions={
                  categoriasDewey ? categoriasDewey : ["Cargando opciones..."]
                }
                getOptionLabel={(option) =>
                  option.nombreCategoria
                    ? `${option.nombreCategoria} - ${option.codigoCategoria}`
                    : ""
                }
                onChange={(e, value, reason) => {
                  if (reason === "clear") {
                    setCategoriaDeweySeleccionada(null);
                    setSubCategoriaDeweyDisponibles([]);
                    setSubCategoriaDeweySeleccionada(null);
                    return;
                  }

                  if (reason === "selectOption") {
                    setCategoriaDeweySeleccionada(value);
                    setSubCategoriaDeweyDisponibles(value?.subcategorias ?? []);
                    setSubCategoriaDeweySeleccionada(null);
                  }
                }}
              />
            </FormControl>
            {categoriaDeweySeleccionada && (
              <FormControl fullWidth margin="dense">
                <SearchOrAdd
                  label={"Subcategoria Dewey"}
                  value={subcategoriaDeweySeleccionada}
                  getOptionLabel={(option) =>
                    option.nombreSubcategoria
                      ? `${option?.nombreSubcategoria || ""} - ${option?.codigoSubcategoria || ""}`
                      : `${option?.codigoSubcategoria || ""}`
                  }
                  isCreationDialogueOpen={isDeweySubcategoryDialogueOpen}
                  setIsCreationDialogueOpen={setIsDeweySubcategoryDialogueOpen}
                  givenOptions={subcategoriasDeweyDisponibles}
                  hasAddForm={true}
                  addForm={
                  <CreateDeweySubcategory
                    onAdd={(picked) => {
                      setCategoriaDeweySeleccionada((prev) => ({
                        ...prev,
                        subcategorias: [...(prev?.subcategorias ?? []), picked],
                      }));
                      setSubCategoriaDeweySeleccionada(picked);
                      setSubCategoriaDeweyDisponibles((prev) => [...prev, picked]);
                    }}
                    isOpen={isDeweySubcategoryDialogueOpen}
                    setIsOpen={setIsDeweySubcategoryDialogueOpen}
                    codigoCategoriaDewey={categoriaDeweySeleccionada?.codigoCategoria ?? ""}
                  />
                  }
                onChange={(e, value, reason) => {
                  if (reason === "clear") {
                    setSubCategoriaDeweySeleccionada(null);
                    return;
                  }

                  if (reason === "selectOption") {
                    setSubCategoriaDeweySeleccionada(value);
                  }
                }}
                />
              </FormControl>
            )}
            <FormControl fullWidth margin="dense">
              <SearchOrAdd
                value={autorSeleccionado}
                label={"Autor*"}
                givenOptions={autores ? autores : ["Cargando opciones..."]}
                hasAddForm={true}
                setIsCreationDialogueOpen={setIsAuthorDialogueOpen}
                isCreationDialogueOpen={isAuthorDialogueOpen}
                addForm={
                  <CreateAuthor
                    onAdd={(picked) => {
                      setAutorSeleccionado(picked);
                      setAutores((prev) => [...prev, picked]);
                    }}
                    title="Crear Nuevo Autor"
                    confirmationText="Crear"
                    actionFunction={agregarAutor}
                    setIsOpen={setIsAuthorDialogueOpen}
                    isOpen={isAuthorDialogueOpen}
                    nuevoAutor={autor}
                    setNuevoAutor={setAutor}
                  />
                }
                getOptionLabel={(option) =>
                  option.nombreAutor
                    ? `${option.nombreAutor} - ${option.codigoCutter}`
                    : ""
                }
                onChange={(e, value, reason) => {
                  if (reason === "clear") {
                    setAutorSeleccionado(null);
                    return;
                  }

                  if (reason === "selectOption") {
                    setAutorSeleccionado(value);
                  }
                }}
              />
            </FormControl>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={nuevoLibro.prestable}
                    onChange={() =>
                      setNuevoLibro((prev) => ({
                        ...prev,
                        prestable: !prev.prestable,
                      }))
                    }
                  />
                }
                label="Prestable"
              />
            </FormGroup>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={nuevoLibro.prestamoEspecial}
                    onChange={() =>
                      setNuevoLibro((prev) => ({
                        ...prev,
                        prestamoEspecial: !prev.prestamoEspecial,
                      }))
                    }
                  />
                }
                label="Prestable Especial"
              />
            </FormGroup>
            {/* Aquí puedes añadir un componente similar para las categorías */}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={
                libroSeleccionado ? handleActualizarLibro : handleCrearLibro
              }
              color="success"
            >
              {libroSeleccionado ? "Actualizar" : "Guardar"}
            </Button>
            <Button
              onClick={() => {
                setDialogoAbierto(false);
                setLibroSeleccionado(null);
                resetNuevoLibro();
                setCategoriaDeweySeleccionada(null);
                setSubCategoriaDeweySeleccionada(null);
                setSubCategoriaDeweyDisponibles([]);
                setFondoSeleccionado(null);
                setCategoriaSeleccionada(null);
                setAutorSeleccionado(null);
                setGeneroField("");
              }}
              color="error"
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
        <div className="tablaInventarioContainer">
          <DataGrid
            loading={loading}
            pageSizeOptions={[{ bookPageSize }]}
            rows={libros}
            rowCount={pagingMetadata.totalElements ?? 0}
            columns={columnas}
            paginationMode="server"
            getRowId={(row) => row.idLibro}
            paginationModel={{
              pageSize: bookPageSize,
              page: bookPageId,
            }}
            onPaginationModelChange={(model) => {
              setBookPageId(model.page);
            }}
            rowHeight={80}
            slots={{ footer: JumpByItemFooter }}
            slotProps={{
              footer: {
                total: pagingMetadata.totalElements ?? 0,
                page: bookPageId,
                pageSize: bookPageSize,
                onJumpPage: (p) => setBookPageId(p),
                noun: "libro",  
              },
            }}
          />
        </div>
      </div>
    );

}
export default TablaInventario;
